import { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { Context } from "../../../context";
import { Column } from "../../flex/styled";

export const SideNavigationWrapper = styled(Column)(({
  USERROLE,
  location,
}) => {
  const { isSideNavigationOpen, setIsSideNavigationOpen } = useContext(Context);
  const [matches, setMatches] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setMatches(window.screen.availWidth >= 1024);
      setIsSideNavigationOpen(matches);
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [matches, setIsSideNavigationOpen]);

  return {
    backgroundColor: "var(--color-background)",
    color: "var(--color-text)",
    position: "fixed",
    scrollbarWidth: "none",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflowY: "auto",
    zIndex: 2,
    display: isSideNavigationOpen ? "flex" : "none",
    "& a": {
      textDecoration: "none",
      color: "var(--color-text)",
      display: "block",
      "&:hover": {
        color: "var(--color-primary)",
      },
    },
    "& .side-navigation-upper-section": {
      borderBottom: "1px solid #E8E8E8",
      "& .switch-companies-box": {
        padding: "var(--cardPadding)",
        paddingTop: 0,
      },
      "& .nav-logo": {
        padding: "var(--cardPadding)",
        paddingBottom:
          USERROLE === "employer" ? 0 : "calc(var(--cardPadding) * 1.7)",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "var(--flexGap)",
        "& p": {
          fontFamily: "Poppins",
          fontWeight: 700,
          fontSize: "24px",
          marginBlock: 0,
          cursor: "pointer",
          color: "var(--color-text)",
        },
        "& button": {
          width: "fit-content",
          borderRadius: "40px",
        },
        "@media screen and (max-width: 425px)": {
          alignItems: "flex-start",
          flexDirection: "column-reverse",
          "& p": {
            width: "100%",
          },
        },
        "@media screen and (min-width: 1024px)": {
          // minHeight: "var(--topNavHeight)",
          boxSizing: "border-box",
          display: "flex",
          alignItems: "center",
          "& button": {
            display: "none",
          },
        },
      },
    },
    "& .nav-links": {
      padding: "var(--cardPadding) 0",
      gap: "0",
      borderBottom: "1px solid #E8E8E8",
      "& a": {
        padding: "1rem var(--cardPadding)",
        display: "flex",
        alignItems: "center",
        transition: "all 0.2s ease",
        textDecoration: "none",
        color: "var(--color-text)",
        "&:hover": {
          backgroundColor: "#FFFFFF",
          color: "var(--color-tertiary)",
          borderRight: "2px solid var(--color-tertiary)",
          "& svg": {
            color: "var(--color-tertiary)",
          },
        },
        "&.active": {
          backgroundColor: "#FFFFFF",
          color: "var(--color-primary) ",
          borderRight: "4px solid var(--color-primary)",
          "& svg": {
            color: "var(--color-primary)",
          },
        },
      },
      "& svg": {
        width: "1.2rem",
        height: "1.2rem",
        transition: "color 0.2s ease",
        flexShrink: 0,
      },
      "& p": {
        cursor: "pointer",
        marginBlock: 0,
        fontSize: "1rem",
        fontWeight: 500,
        "&:active": {
          color: "var(--color-primary)",
        },
      },
    },
    "& .nav-avatar-area": {
      padding: "var(--cardPadding)",
      marginTop: "auto",
      borderTop: "1px solid #FFFFFF",
    },
    "& .sub-items": {
      marginBlock: 0,
      listStyleType: "none",
      display: "flex",
      flexDirection: "column",
      gap: "calc(var(--flexGap)/3)",
      paddingInlineStart: "calc(var(--cardPadding))",
      "& p": {
        cursor: "pointer",
        marginBlock: 0,
        "&:hover": {
          color: "var(--color-primary)",
        },
      },
      "& .active-company, .inactive-company": {
        color: "var(--color-text)",
        "&:hover": {
          color: "var(--color-primary)",
        },
      },
    },
    "& .user-companies-dropdown": {
      marginBlockStart: "calc(var(--flexGap)/3)",
    },
    "& .call-to-action-buttons": {
      padding: "0 calc(var(--cardPadding)/1)",
      gap: "0.75rem",
      flexWrap: "wrap",
      alignItems: "stretch",
      "& span": {
        whiteSpace: "nowrap",
      },
      "& .nav-action-item": {
        position: "relative",
      },
      "& button": {
        width: "fit-content",
      },
      "& .nav-action-button": {
        display: "none",
        alignItems: "center",
        gap: ".4rem",
        backgroundColor:
          location === "departments" ? "var(--color-primary)" : undefined,
        "& svg": {
          padding: "0.5rem",
          width: "1.2rem",
          height: "1.2rem",
          flexShrink: 0,
          color: "#FFFFFF",
        },
        "& .action-caret": {
          marginLeft: "auto",
          background: "transparent",
          color: "#FFFFFF",
          padding: 0,
          borderRadius: 0,
        },
        "@media screen and (max-width: 768px)": {
          display:
            location === "dashboard" ||
            location === "employees" ||
            location === "departments" ||
            location === "employer-profile" ||
            location === "payroll" ||
            location === "summary" ||
            location === "variance" ||
            location === "general-report" ||
            location === "paye" ||
            location === "pension" ||
            location === "pricing" ||
            location === "wallet"
              ? "inline-flex"
              : "none",
        },
      },
      "& .action-dropdown": {
        position: "absolute",
        top: "calc(100% + 10px)",
        left: 0,
        right: 0,
        margin: 0,
        padding: "0.35rem 0",
        listStyleType: "none",
        backgroundColor: "#FFFFFF",
        borderRadius: "18px",
        boxShadow: "0 14px 28px rgba(0, 0, 0, 0.12)",
        zIndex: 4,
        overflow: "hidden",
        "& li": {
          margin: 0,
        },
        "& button": {
          width: "100%",
          background: "transparent",
          border: "none",
          textAlign: "left",
          padding: "0.85rem 1.1rem",
          fontFamily: "Poppins",
          fontSize: "14px",
          color: "var(--color-text)",
          cursor: "pointer",
          borderRadius: 0,
          "&:hover": {
            backgroundColor: "var(--color-background)",
            color:
              location === "departments"
                ? "var(--color-primary)"
                : "var(--color-primary)",
          },
        },
      },
      "@media screen and (max-width: 450px)": {
        "& button": {
          width: "-webkit-fill-available",
        },
      },
    },
    "& .logo-box-area": {
      maxWidth: "100%",
      "& svg": {
        width: "100%",
        height: "auto",
      },
    },
    "@media screen and (min-width: 1024px)": {
      left: "auto",
      right: "auto",
      width: "var(--sideNavWidth)",
    },
  };
});
